/** A submenu to the StandardMenu that _tries_ to be smart about which side,
 *  right or left, that it should render on.
 *
 *  Send it into a group of menu items like this:
 *    {
 *      label: 'do something',
 *      icon: <Icon size={IconSize.SMALL} />,
 *      disabled: isDisabled,
 *      submenu: (
 *        <StandardMenu
 *          ...
 *        />
 *      ),
 *      componentProps: {
 *        preferredSide: 'left',
 *        estimatedSubmenuWidth: 200,
 *      }
 *    }
 *
 *   Note: you currently can't use a label or scrollable={true}
 *   on the enclosing menu (or the submenu will appear inside
 *   the scrollable content)
 */
// impl. note: this uses MenuItem's componentClass and componentProps
// to turn this whole component into a menu item
// TODO: the render chain is very snaky and should be simplified at some point
import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import ArrowRightIcon from '../../../Icons/ArrowRight';
import { IconSize } from '../../../Icons/IconWrap';
import { withMobileContext } from '../../../Context';
import * as s from './StandardMenuSubmenu.scss';
import * as StandardMenuStyles from './StandardMenu.scss';
var defaultProps = {
    disabled: false,
    preferredSide: 'right',
    estimatedSubmenuWidth: 120,
};
var StandardMenuSubmenu = /** @class */ (function (_super) {
    tslib_1.__extends(StandardMenuSubmenu, _super);
    function StandardMenuSubmenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            submenuIsOpen: false,
            sideToRenderSubmenu: undefined,
        };
        _this.rootRef = React.createRef();
        _this.toggleSubmenu = function () {
            _this.state.submenuIsOpen ? _this.closeSubmenu() : _this.openSubmenu();
        };
        _this.openSubmenu = function () {
            var sideToRenderSubmenu = _this.pickASide();
            _this.setState({
                submenuIsOpen: true,
                sideToRenderSubmenu: sideToRenderSubmenu,
            });
        };
        _this.closeSubmenu = function () {
            _this.setState({ submenuIsOpen: false });
        };
        return _this;
    }
    StandardMenuSubmenu.prototype.render = function () {
        var _a = this.props, className = _a.className, disabled = _a.disabled, children = _a.children, submenu = _a.submenu, isMobile = _a.isMobile;
        var _b = this.state, submenuIsOpen = _b.submenuIsOpen, sideToRenderSubmenu = _b.sideToRenderSubmenu;
        var classNames = classnames(s['root'], disabled && StandardMenuStyles['disabled'], submenuIsOpen ? s['submenu-open'] : s['submenu-closed'], sideToRenderSubmenu === 'left' && s['submenu-left'], className);
        return (React.createElement("div", tslib_1.__assign({ className: classNames, ref: this.rootRef, "aria-expanded": submenuIsOpen, "aria-disabled": disabled }, (isMobile
            ? {
                onClick: this.toggleSubmenu,
            }
            : {
                onMouseOver: this.openSubmenu,
                onMouseLeave: this.closeSubmenu,
            })),
            children,
            React.createElement(ArrowRightIcon, { className: s['arrow'], size: IconSize.SMALL }),
            React.createElement("div", { className: s['submenu'] }, submenu)));
    };
    /** based on pref props, estimated sizes, and bounds get the best side
     *  to render the submenu on */
    StandardMenuSubmenu.prototype.pickASide = function () {
        var _a = this.props, preferredSide = _a.preferredSide, estimatedSubmenuWidth = _a.estimatedSubmenuWidth;
        var room = this.checkForRoom();
        if (preferredSide && room[preferredSide] >= estimatedSubmenuWidth) {
            return preferredSide;
        }
        return room.left > room.right ? 'left' : 'right';
    };
    /** return how many pixels from the menuitem/open-button to the inner
     *  edges of the browser page */
    StandardMenuSubmenu.prototype.checkForRoom = function () {
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        var bounds = this.rootRef.current.getBoundingClientRect();
        return {
            left: bounds.left,
            right: viewportWidth - bounds.right,
        };
    };
    StandardMenuSubmenu.defaultProps = defaultProps;
    return StandardMenuSubmenu;
}(React.Component));
export { StandardMenuSubmenu };
export default withMobileContext(StandardMenuSubmenu);
//# sourceMappingURL=StandardMenuSubmenu.js.map